import { Distribute, IconButton, SvgClose } from '@loomhq/lens';
import cx from 'classnames';
import Mousetrap from 'mousetrap';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CSSTransitionGroup } from 'react-transition-group';

import { updateAddReplyId } from 'actions/comments';
import { ESCAPE_LITERAL } from 'constants/keyCodes';
import { KEY_UP } from 'constants/keyEvents';
import { videoPlayerHideComments } from 'creators/videoPlayer';

import CommentsContent from '../../share-video/comments/player-content';

import styles from './styles.module.less';

const TRANSITION_DURATION = 150;

const AllCommentsOverlay = () => {
  const dispatch = useDispatch();

  const showAllComments = useSelector(
    state => state.video_player.show_all_comments
  );

  const close = useCallback(() => {
    dispatch(videoPlayerHideComments());
    dispatch(updateAddReplyId(null));
  }, [dispatch]);

  const [containerRef, setContainerRef] = useState(null);

  useEffect(() => {
    Mousetrap.bind(ESCAPE_LITERAL, close, KEY_UP);

    return () => {
      Mousetrap.unbind(ESCAPE_LITERAL, KEY_UP);
    };
  }, [close]);

  const classes = ['theme-dark', styles.commentsOverlay];

  if (!showAllComments) {
    classes.push(styles.hidden);
  }

  return (
    <CSSTransitionGroup
      transitionName={{
        enter: styles.overlayEnter,
        enterActive: styles.overlayEnterActive,
        leave: styles.overlayLeave,
        leaveActive: styles.overlayLeaveActive,
      }}
      transitionEnterTimeout={TRANSITION_DURATION}
      transitionLeaveTimeout={TRANSITION_DURATION}
    >
      <div className={cx(classes)}>
        <div
          className={styles.scrollContainer}
          ref={newRef => setContainerRef(newRef)}
        >
          <div className={styles.headerWrapper}>
            <Distribute
              alignment="center"
              className={styles.commentHeader}
              gap="auto"
              marginBottom="small"
            >
              <span>Comments</span>
              <IconButton altText="Close" icon={<SvgClose />} onClick={close} />
            </Distribute>
          </div>
          <div className={styles.commentFeed}>
            <CommentsContent
              drawnOnSharePage={false}
              scrollContainer={containerRef}
            />
          </div>
        </div>
      </div>
    </CSSTransitionGroup>
  );
};

export { AllCommentsOverlay };
